import { render } from "./Forum.vue?vue&type=template&id=0be067a9&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"

import "./Forum.vue?vue&type=style&index=0&id=0be067a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be067a9"]])

export default __exports__